import * as api from "../api";

export const getComments = (postId) => async (dispatch) => {
    try {
        const { data } = await api.fetchComments(postId);
        dispatch({ type: 'FETCH_COMMENTS', payload: data, postId });
    } catch (error) {
        console.error("Error fetching comments:", error.message);
    }
};
export const createComment = (payload, setLoading, clear, toast) => async (dispatch) => {
    try {
        setLoading(true)
        const postId = payload.postId;
        console.log("Creating comment for postId:", postId);
        const { data } = await api.createComment(postId, payload);
        dispatch({ type: 'ADD_COMMENT', payload: data });
        dispatch(getComments(postId))
        setLoading(false)
        toast.success('You have submitted a comment successfully')
        clear()

    } catch (error) {
        setLoading(false)
        toast.error(error.response.data || 'ERR_CONNECTION_REFUSED');
        console.log(error)
    }
}